<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row wrap>


				<v-flex xs12 md6 pa-2>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-btn icon @click="gotoOrganizations()">
								<v-icon>arrow_back_ios</v-icon>
							</v-btn>
							<v-toolbar-title>{{ domain }}</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn v-if="!isLoading" icon @click="addNewUser()">
								<v-icon>add_circle</v-icon>
							</v-btn>
						</v-toolbar>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">İşlem devam ediyor</div>
							</div>
						</template>
						<template v-if="!isLoading">

							<v-list>
								<template v-for="(user, userIndex) in users">
									<v-list-tile :key="userIndex" avatar @click="loginUser(user)">
										<v-list-tile-avatar>
											<img v-if="user.gender == 'male'" src="@/assets/default/user-male.png">
											<img v-if="user.gender == 'female'" src="@/assets/default/user-female.png">
										</v-list-tile-avatar>

											<v-list-tile-content>
												<v-list-tile-title>{{user.name.first}} {{user.name.last}}</v-list-tile-title>
												<v-list-tile-sub-title>{{user.email}}</v-list-tile-sub-title>
											</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

				<v-flex xs12 md6 pa-2>
					<v-card>
						<v-toolbar color="orange darken-4" dark> 
							<v-toolbar-title>Listeler</v-toolbar-title>
							<v-spacer></v-spacer>
							<v-btn v-if="!isGroupsLoading" icon @click="addNewGroup()">
								<v-icon>add_circle</v-icon>
							</v-btn>
						</v-toolbar>
						<template v-if="isGroupsLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">İşlem devam ediyor</div>
							</div>
						</template>
						<template v-if="!isGroupsLoading">

							<v-list>
								<template v-for="(group, groupIndex) in groups">
									<v-list-tile v-if="group.type == 'generic'" :key="groupIndex" avatar @click="loginGroup(group)">
										<v-list-tile-avatar> 
											<img src="@/assets/default/group.png">
										</v-list-tile-avatar>

											<v-list-tile-content>
												<v-list-tile-title>{{group.name}}</v-list-tile-title>
												<v-list-tile-sub-title>{{group.email}}</v-list-tile-sub-title>
											</v-list-tile-content>
									</v-list-tile>
								</template>
							</v-list>
						</template>
					</v-card>
				</v-flex>

 


			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "MailOrganizations",

		data : () => ({
			isLoading: true,
			isGroupsLoading: true,

			account : "",
			domain : "",
			domain_id : "",

			users : [],
			groups : [],

		}),

		mounted(){
			this.account = this.$route.query.account
			this.domain = this.$route.query.domain
			this.domain_id = this.$route.query.domain_id
			this.isLoading = true; 
			this.$http.get( process.env.VUE_APP_API_URL + "/email/users", {
				params : {
					account: this.account,
					domain_id: this.domain_id
				}
			}).then(response => {  
				this.users = response.body;
				this.isLoading = false; 
			}) 
			this.$http.get( process.env.VUE_APP_API_URL + "/email/groups", {
				params : {
					account: this.account,
					domain_id: this.domain_id
				}
			}).then(response => {  
				this.groups = response.body;
				this.isGroupsLoading = false; 
			}) 
		},

		methods : {
			loginUser(user){
				this.$router.push({ 
					path: '/email/users/edit', query: { 
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: user.id
					}
				})
			},
			addNewUser(){
				this.$router.push({ 
					path: '/email/users/edit', query: { 
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: ""
					}
				})
			},
			loginGroup(group){
				this.$router.push({ 
					path: '/email/groups/edit', query: { 
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						group_id: group.id
					}
				})
			},
			addNewGroup(){
				this.$router.push({ 
					path: '/email/groups/edit', query: { 
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						group_id: ""
					}
				})
			},
			gotoOrganizations(){
				this.$router.push({ 
					path: '/email', query: { } 
				})
			}
		},

		computed : { 
		}

	}
</script>